import React from "react";
import { Modal } from "semantic-ui-react";
import "./CommonModal.css";

const CommonModal = ({
    open,
    onClose,
    title,
    subtitle,
    children,
    size = "large",
    className = "",
    showCloseButton = true,
    closeOnDimmerClick = true,
    ...props
}) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            size={size}
            className={`common-modal ${className}`}
            closeOnDimmerClick={closeOnDimmerClick}
            closeIcon={showCloseButton}
            {...props}
        >
            {(title || subtitle) && (
                <Modal.Header className="common-modal-header">
                    <div className="common-modal-header-content">
                        {title && (
                            <h3 className="common-modal-title">{title}</h3>
                        )}
                        {subtitle && (
                            <p className="common-modal-subtitle">{subtitle}</p>
                        )}
                    </div>
                </Modal.Header>
            )}
            <Modal.Content className="common-modal-content">
                {children}
            </Modal.Content>
        </Modal>
    );
};

export default CommonModal;

